import { pmpDealType } from '@openx/types/deal.ts';
import type { TFunction } from 'i18next';
import type { RequestDirectDealForm } from './types.ts';

export const defaultValues: RequestDirectDealForm = {
  dealType: 'Private Auction (PMP)',
  advertiserBrand: '',
  budget: '',
  startDate: null,
  endDate: null,
  targetingDetails: '',
};

export const getFormLabels = (t: TFunction) => ({
  dealType: t('Deal Type'),
  advertiserBrand: t('Advertiser / Brand (optional)'),
  budget: t('Budget (optional)'),
  startDate: t('Start Date (optional)'),
  endDate: t('End Date (optional)'),
  targetingDetails: t('Targeting Details (optional)'),
});

export const getFormPlaceholders = (t: TFunction) => ({
  dealType: t('[ Select deal type ]'),
  advertiserBrand: t('Enter Advertiser / Brand Name'),
  budget: '0.00',
  targetingDetails: t('Describe key Targeting Requirements, including Audience Data and Inventory Specifics.'),
});

/**
 * currently the feature is being implemented in the OXS,
 * and since we don't use Deal Type anywhere else in the OXS we keep the labels here.
 */
export const getDealTypeLabels = (t: TFunction) => ({
  [pmpDealType.PrivateAuction]: t('Private Auction (PMP)'),
  [pmpDealType.Guaranteed]: t('Programmatic Guaranteed (PG)'),
});
